module.exports = __webpack_public_path__ + "media/images/kumu-virtual-gifts-5935c27521de33bff5141cafb9261967.svg";